import React from 'react'

import s from './Avatar.module.css'

interface AvatarProps {
  src?: string
  alt?: string
  name?: string
  size?: 'md' | 'lg'
}

export const Avatar: React.FC<AvatarProps> = ({
  src,
  alt,
  name,
  size = 'lg',
}) => {
  const getInitials = (name: string) => {
    const [firstName, lastName] = name.split(' ')
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase()
  }

  return (
    <div className={`${s.avatar} ${s[size]}`}>
      {src ? (
        <img src={src} alt={alt || name} className={s.image} />
      ) : (
        <span className={s.initials}>{getInitials(name ?? '')}</span>
      )}
    </div>
  )
}
